var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1269"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1269"
    },
    "bundlingPackage": "marketplace-storefront-public-ui",
    "bundlingPackageVersion": "static-1.13445",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};